interface CursorPaginationProps {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}

export default function CursorPagination({ hasMore, loading, onLoadMore }: CursorPaginationProps) {
  if (!hasMore && !loading) return null;

  return (
    <div className="admin-pagination" style={{ justifyContent: 'center', padding: '1rem 0' }}>
      {loading ? (
        <div className="admin-loading-spinner" style={{ width: 24, height: 24 }}></div>
      ) : hasMore ? (
        <button className="admin-btn admin-btn-outline" onClick={onLoadMore}>
          Load More
        </button>
      ) : null}
    </div>
  );
}
